<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>
import MainLayout from '@/layouts/MainLayout.vue';
import AuthLayout from '@/layouts/AuthLayout.vue';
import BlankLayout from '@/layouts/BlankLayout.vue';

export default {
  computed: {
    layout() {
      const layout = this.$route.meta.layout;

      switch (layout) {
        case 'auth':
          return AuthLayout;
        case 'main':
          return MainLayout;
        default:
          return BlankLayout;
      }
    },
  },
};
</script>

<style>
:root {
  --date-position: 4px;
  --month-position: 22px;
  --year-position: 32px;
  --table-color-header: #d9ebff;
}

input[type='date']::-webkit-datetime-edit,
input[type='date']::-webkit-inner-spin-button,
input[type='date']::-webkit-clear-button {
  color: #fff;
  display: hidden;
  position: relative;
}

input[type='date']::-webkit-datetime-edit-year-field {
  position: absolute !important;
  color: #000;
  left: calc(var(--date-position) + var(--month-position) + var(--year-position));
}

input[type='date']::-webkit-datetime-edit-month-field {
  position: absolute !important;
  color: #000;
  left: calc(var(--date-position) + var(--month-position));
  border-inline: 1px solid black;
  padding-inline: 4px;
}

input[type='date']::-webkit-datetime-edit-day-field {
  position: absolute !important;
  color: #000;
  left: var(--date-position);
}

.v-toolbar__content {
  padding: 0 !important;
}

.main {
  padding: 2rem;
}

table {
  border-collapse: collapse;
}

.flex {
  display: flex;
}

.table-head {
  background-color: var(--table-color-header) !important;
}

.border {
  border: 0.5px solid rgba(0, 0, 0, 0.2);
}

@media print {
  .print\:hidden {
    display: none !important;
  }
}
</style>
